"use client";

import { Check, Copy } from "lucide-react";
import { useState } from "react";

type CodeBlockProps = {
	code: string;
	language: string;
};

export function CodeBlock({ code, language }: CodeBlockProps) {
	const [copied, setCopied] = useState(false);

	async function copyToClipboard() {
		await navigator.clipboard.writeText(code);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	}

	return (
		<div className="relative group">
			<button
				type="button"
				onClick={copyToClipboard}
				className="absolute top-3 right-3 p-2 rounded-lg bg-gray-800 hover:bg-gray-700 text-gray-400 hover:text-gray-200 transition opacity-0 group-hover:opacity-100"
				aria-label="Copy code"
			>
				{copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
			</button>
			<pre className="bg-gray-900 rounded-lg p-4 overflow-x-auto">
				<code className="text-sm text-gray-100 font-mono whitespace-pre">
					{code}
				</code>
			</pre>
		</div>
	);
}
